<template>
  <v-app id="searchklnt">
    <v-main>
      <v-container fluid v-show="showParameters">
        <v-row class="mx-2">
          <v-col cols="2">
            <v-text-field v-model="klntCode" label="Id" @keyup.enter="getklnt"></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field v-model="klntNaam" hint="Use of wildcards (*<input>*) supported" label="Lastname" @keyup.enter="getklnt" autocomplete="new-klnt-naam"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mx-2">
          <v-col cols="4">
            <v-text-field v-model="klntEmail" hint="Use of wildcards (*<input>*) supported" label="E-mail address" @keyup.enter="getklnt" autocomplete="new-klnt-email"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="klntTelephone" hint="Use of wildcards (*<input>*) supported" label="Phone" @keyup.enter="getklnt" autocomplete="new-klnt-telephone"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mx-2">
          <v-col cols="1" span="2" style="display: flex; flex-direction: row; gap: 20px;">
            <v-btn class="warning ma-0" small @click="parametersShow()" v-if="showClearButton"><v-icon left>mdi-refresh</v-icon>Clear</v-btn>
            <v-btn class="primary ma-0" small @click="getklnt()"><v-icon left>mdi-magnify</v-icon>Search</v-btn>
            <v-btn v-if="filteredItems.length > 0" class="primary ma-0" small @click="showParameters = false"><v-icon left>mdi-eye-off-outline</v-icon>Hide parameters</v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-container fluid>
        <v-btn v-show="!showParameters" class="primary ma-0" small @click="parametersShow()"><v-icon left>mdi-eye-outline</v-icon>Show parameters</v-btn>
        <div v-if="results">
          <v-card flat class="px-2">
            <v-text-field v-model="search" label="Search in results" single-line hide-details prepend-icon="mdi-magnify"></v-text-field>
            <v-data-table :items="filteredItems" :headers="headers" hide-default-footer :search="search"
              :items-per-page="getRowsPerPage()" :page.sync="page" no-data-text="No guest(s) to display"
              loading-text="Loading data...please wait" :loading="loading">
              <template v-slot:item="props">
                <tr>
                  <td @click="$router.open('/klnt/onKlnt/' + props.item.klnt_encrid)"><a> {{ props.item.klnt_code }} </a>
                  </td>
                  <td>{{ props.item.klnt_voornaam }}</td>
                  <td>{{ props.item.klnt_naam }}</td>
                  <td>{{ props.item.klnt_email }}</td>
                  <td>{{ props.item.klnt_email_extra }}</td>
                  <td>{{ props.item.klnt_telephone }}</td>
                </tr>
              </template>
            </v-data-table>
            <div v-if="!loading && items.length > 0"
              style="display: flex; align-items: center; justify-content :end; margin-top: 20px; font-size: small; color:grey;">
              <v-btn icon @click="goToFirstPage" :disabled="page === 1"><v-icon>mdi-chevron-double-left</v-icon></v-btn>
              <v-btn icon @click="goToPreviousPage" :disabled="page === 1"><v-icon>mdi-chevron-left</v-icon></v-btn>
              <div style="display: flex; justify-content: center; align-items: center; margin-left: 15px; margin-right: 15px; min-width: 80px;">Page {{ page }} of {{ lastPage }}</div>
              <v-btn icon @click="goToNextPage" :disabled="page === lastPage"><v-icon>mdi-chevron-right</v-icon></v-btn>
              <v-btn icon @click="goToLastPage" :disabled="page === lastPage"><v-icon>mdi-chevron-double-right</v-icon></v-btn>
              <div style="margin-left: 15px; min-width: 150px;">Record {{ startRecord }}-{{ eindRecord }} of {{ this.filteredItems.length }}</div>
            </div>
          </v-card>
        </div>
      </v-container>
    </v-main>
    <navBar title="Ares - Main menu" :home="true" :accolist="false" type="main" />
    <standard_dialog ref="standard_dialog" @standard_dialog_close="parametersShow(false)" />
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import standard_dialog from '@/components/ui/standard_dialog.vue';
export default {
  components: {
    navBar,
    standard_dialog
  },
  data() {
    return {
      results: false,
      showParameters: true,
      items: [],
      klntCode: '',
      klntNaam: '',
      klntEmail: '',
      klntTelephone: '',
      search: '',
      loading: false,
      showClearButton: false,
      page: 1,
      headers: [
        { text: 'Id', value: 'klnt_code' },
        { text: 'Name', value: 'klnt_voornaam' },
        { text: 'Surname', value: 'klnt_naam' },
        { text: 'Email', value: 'klnt_email' },
        { text: 'Email (extra)', value: 'klnt_email_extra' },
        { text: 'Telephone', value: 'klnt_telephone' }
      ]
    }
  },
  created() {
    this.parametersShow()
  },
  computed: {
    lastPage() {
      return Math.ceil(this.filteredItems.length / this.getRowsPerPage());
    },
    startRecord() {
      return (this.page - 1) * this.getRowsPerPage() + 1;
    },
    eindRecord() {
      return Math.min(this.page * this.getRowsPerPage(), this.filteredItems.length);
    },
    filteredItems() {
      if (!this.search) {
        return this.items;
      }
      const lowerCaseSearch = this.search.toLowerCase();
      return this.items.filter(item =>
        item.klnt_code.toLowerCase().includes(lowerCaseSearch) ||
        item.klnt_voornaam.toLowerCase().includes(lowerCaseSearch) ||
        item.klnt_naam.toLowerCase().includes(lowerCaseSearch) ||
        item.klnt_email.toLowerCase().includes(lowerCaseSearch) ||
        item.klnt_email_extra.toLowerCase().includes(lowerCaseSearch) ||
        item.klnt_telephone.toLowerCase().includes(lowerCaseSearch)
      );
    },
  },
  methods: {
    goToFirstPage() {
      this.page = 1;
    },
    goToLastPage() {
      this.page = this.lastPage;
    },
    goToPreviousPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    goToNextPage() {
      if (this.page < this.lastPage) {
        this.page++;
      }
    },
    getRowsPerPage() {
      return this.$vuetify.breakpoint.lgAndDown ? 9 : 13;
    },
    parametersShow(clearParams=true) {
      if(clearParams) {
        this.klntCode = ''
        this.klntNaam = ''
        this.klntEmail = ''
        this.klntTelephone = ''
      }
      this.items = []
      this.results = false
      this.showParameters = true;
      this.search = ''
    },
    getklnt() {
      this.results = true;
      this.showParameters = false;
      this.loading = true;
      this.items = [];
      this.$axios
        .post("ares/json/ares/klnt/searchKlnt4.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchKlnt"
          },
          searchKlnt: {
            klnt_code: this.klntCode,
            klnt_naam: this.klntNaam,
            klnt_email: this.klntEmail,
            klnt_telephone: this.klntTelephone
          }
        })
        .then(res => {
          if (res.data.error) {
            this.$refs.standard_dialog.setWidth(450);
            this.$refs.standard_dialog.setTextClass("text-center text-body-1 pa-3 pt-6");
            this.$refs.standard_dialog.open('warning', 'Warning', res.data.error.message);
            this.showClearButton = true
            this.loading = false;
          } else {
            this.items = res.data.searchKlnt;
            this.showClearButton = false
            this.loading = false;
          }
        })
    }
  }
};

</script>
